module.exports = __webpack_public_path__ + "img/ma.c1da28dd.svg";